<template>
  <div>
    <app-header><app-nav></app-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Contacto</h2>
      </div>

    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import AppNav from './Nav.vue'

export default {
  name: 'Contacto',
  components: {
    AppHeader,
    AppNav
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Contacto.vue?1af5700a